import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { SectionClass } from "../../../core/json/SectionClass";
import {
  addNewSection,
  editSection,
  getZoneList,
} from "../../../services/MasterApiServices";
import { useDispatch, useSelector } from "react-redux";
import { fetchSection } from "../../../redux/userSetting";
import { fetchAllSection } from "../../../redux/getallmatser";
import Select from "react-select";


const SectionModal = ({ mode, data, handleClose, handleRefresh }) => {

  //get branch from redux
  const { branch } = useSelector((state) => state.branchlist);
  const dispatch = useDispatch();
  // Get user from redux
  const { userId } = useSelector((state) => state.userauth);

  const { register, handleSubmit, setValue, reset, setFocus, watch } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
const [zoneOptions, setZoneOptions] = useState([]);
const [selectedZone, setSelectedZone] = useState(null);


// function resetmodal() {
//   if (mode === "edit" && data) {
//     setValue("name", data.name);
//     setValue("shortName", data.shortName);
//    setValue("zoneGuID", data.zoneGuID || "");// Add this line
//   } else {
//     reset();
//   }
// }

function resetmodal() {
  if (mode === "edit" && data) {
    setValue("name", data.name);
    setValue("shortName", data.shortName);

    // ✅ Find and set the selected zone object for react-select
    if (data.zoneGuID && zoneOptions.length > 0) {
      const matchedZone = zoneOptions.find(
        (zone) => zone.value === data.zoneGuID
      );
      setSelectedZone(matchedZone || null);
      setValue("zoneGuID", matchedZone?.value || "");
    } else {
      setSelectedZone(null);
      setValue("zoneGuID", "");
    }
  } else {
    reset();
    setSelectedZone(null);
  }
}
  // useEffect(() => {
  //   resetmodal();
  // }, [data, mode, setValue]);

  useEffect(() => {
  if (zoneOptions.length > 0) {
    resetmodal();
  }
}, [zoneOptions, data, mode]);


  useEffect(() => {
    const timeout = setTimeout(() => setFocus("name"), 0);
    return () => clearTimeout(timeout);
  }, []);
  // Handle form submission for adding or editing a category
// useEffect(() => {
//   const loadZones = async () => {
//     try {
// const response = await getZoneList();
// console.log("Full zone response:", response);

// const zones = Array.isArray(response) ? response : 
//                Array.isArray(response?.data) ? response.data : 
//                Array.isArray(response?.zones) ? response.zones : [];

// if (zones.length > 0) {
//   const formatted = zones.map((zone) => ({
//     value: zone.guid,
//     label: zone.name,
//   }));
//   setZoneOptions(formatted);
//   console.log("Formatted Zone Options:", formatted);
// } else {
//   console.warn("No zones found in response");
// }

//     } catch (error) {
//       toast.error(error?.response?.data?.Message || "Something went wrong");
//       console.error("Error fetching zone list:", error);
//     }
//   };
//   loadZones();
// }, []);

useEffect(() => {
  const loadZones = async () => {
    try {
      const response = await getZoneList();
      const zones = Array.isArray(response)
        ? response
        : Array.isArray(response?.data)
        ? response.data
        : Array.isArray(response?.zones)
        ? response.zones
        : [];

     let branchZones = zones.filter(
  (zone) => zone?.branchID === branch?.guid
);


      // ✅ If editing and selected zone is not in current branch, include it
      if (mode === "edit" && data?.zoneGuID) {
        const selectedZone = zones.find((zone) => zone.guid === data.zoneGuID);
        if (selectedZone && !branchZones.some(z => z.guid === selectedZone.guid)) {
          branchZones = [...branchZones, selectedZone];
        }
      }

      const formatted = branchZones.map((zone) => ({
        value: zone.guid,
        label: zone.name,
      }));

      setZoneOptions(formatted);
    } catch (error) {
      toast.error(error?.response?.data?.Message || "Something went wrong");
      console.error("Error fetching zone list:", error);
    }
  };

  if (branch?.guid) loadZones();
}, [branch?.guid, mode, data?.zoneGuID]);


useEffect(() => {
  register("zoneGuID");
}, [register]);

useEffect(() => {
  console.log("Formatted Zone Options", zoneOptions);
}, [zoneOptions]);

  const handleFormSubmit = async (formData) => {
    const objsection = new SectionClass();
    objsection.name = formData.name;
    objsection.shortName = formData.shortName;
    objsection.updatedUser = `{${userId?.id}}`; //"{9b57619d-63c8-4e27-9a59-639f0c80e4a1}"; //userId
    objsection.Branch = branch;
    objsection.zoneGuID = formData.zoneGuID;
    if (mode === "edit") {
      objsection.guid = data.guid;
      objsection.id = data.id;
    }

    try {
      const response =
        mode === "edit"
          ? await editSection(objsection)
          : await addNewSection(objsection);

      if (response) {
        toast.success("Success");
        handleRefresh(); // Refresh the list
        dispatch(fetchSection(branch.guid));
        dispatch(fetchAllSection());
        handleClose(); // Close the modal
      } else if (response == false) {
        toast.error("false");
      }
    } catch (error) {
      toast.error(error?.response?.data?.Message || "something went wrong");
      console.error(
        "Error handling :",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  return (
    <div>
      <div
        className="modal fade show"
        style={{ display: "block" }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>{mode === "edit" ? "Edit Section" : "Add Section"}</h4>
                  </div>
                  <button type="button" className="close" onClick={handleClose}>
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form onSubmit={handleSubmit(handleFormSubmit)}>
                    <div className="row">
                      <div className="col-md-6 col-sm-12">
                        <div className="input-blocks">
                          <label>
                            Name<span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Name"
                            {...register("name")}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-12">
                        <div className="input-blocks">
                          <label>
                            Short Name<span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Short Name"
                            {...register("shortName")}
                            required
                          />
                        </div>
                      </div>
                  <div className="col-12">
                        <div>
                          <label>Select Zone</label>
                         <Select
  classNamePrefix="react-select"
  options={zoneOptions}
  isClearable={true}
  placeholder="Select Zone"
  value={zoneOptions.find((opt) => opt.value === watch("zoneGuID")) || null}
  onChange={(selected) => setValue("zoneGuID", selected?.value || "")}
  styles={{
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  }}
  menuPortalTarget={document.body}
/>

                        </div>
                      </div>

                    </div>

                    <div className="col-lg-12">
                      <div className="modal-footer-btn">
                        <button
                          type="button"
                          className="btn btn-cancel me-2"
                          onClick={() => resetmodal()}
                        >
                          Reset
                        </button>
                        <button type="submit" className="btn btn-submit">
                          {mode === "edit" ? "Save Changes" : "save"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionModal;
